import Navbar from "./Navbar";

const Header = () => {
  return (
    <header>
      <h1>
        <u>Patient Tracker and Invoice Generator</u>
      </h1>
      <Navbar />
    </header>
  );
};

export default Header;
